var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInactiveRentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    x2: 0.084,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e3e4e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a2a5b1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3311",
    "data-name": "Group 3311",
    transform: "translate(-392 -212)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1141",
    "data-name": "Rectangle 1141",
    width: 24,
    height: 24,
    rx: 4,
    transform: "translate(392 212)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-md-time",
    "data-name": "Icon ionic-md-time",
    transform: "translate(391.125 211.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21412",
    "data-name": "Path 21412",
    d: "M12.866,3.375a9.5,9.5,0,1,0,9.509,9.5A9.5,9.5,0,0,0,12.866,3.375Zm.009,17.1a7.6,7.6,0,1,1,7.6-7.6A7.6,7.6,0,0,1,12.875,20.475Z",
    fill: "#f3f3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21413",
    "data-name": "Path 21413",
    d: "M17.987,10.688h-1.45v5.8l5.075,3.044.725-1.19-4.35-2.579Z",
    transform: "translate(-4.677 -2.632)",
    fill: "#f3f3f3"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveRentIcon);
export default __webpack_public_path__ + "static/media/InactiveRentIcon.18204725eb68ca915d90c48b38b763e4.svg";
export { ForwardRef as ReactComponent };